export default "__VITE_ASSET__BbHPRmE3__"